import { inject, Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
@Injectable({
	providedIn: 'root',
})
export class DatastoreService {

	agentRestart() {
		// clear all localstorage
		localStorage.clear();

		//clear all session storage
		sessionStorage.clear();

		//clear variables
		this.startQuestions = null;
		this.type_of_ceremony = null;
		this.totalCost = null;
		this.reference = null;

		this.deepLinkedService = null;
		this.deepLinkedResource = null;
		this.storedFee = null;
		this.costBreakDown = null;
		this.setService = null;
		this.setResource = null;

		this.extraDuration = 0;
		// client details
		this.booker_first_name = null;
		this.booker_last_name = null;
		this.booker_email = null;
		this.booker_phone = null;
		this.costBreakDown = null;
		this.setService = null;
		this.setResource = null;
		this.extraDuration = 0; // obtained from questions
		this.bookingQuestions = [];
		this.unselectedLocations = [];
		this.bookingForm = null;
		this.companyAnswers = null;
		this.selectedDate = null;
		this.selectedSlot = null;
		this.selectedResource = null;
		this.selectedService = null; //used only to store the service incase we switch to the alt one
		this.selectedDepartment = null; //used only to store the service incase we switch to the alt one
		this.locations = [];
		this.bookingAnswers = null;
		this.clientCreated = false;
		this.address = null;
		this.address1 = null;
		this.latitude = null;
		this.longitude = null;
		this.customerQuestions = null;
		this.companyQuestions = null;
		this.serviceFees = null;
		this.feesUnavailable = false;
		this.selectedDate = null;
		this.selectedResource = null;
		this.selectedService = null;
		this.selectedAddress = null;

		this.adminAuthToken = '';
		this.adminJourney = false;

		this.journeyRoute = '';
		this.queryParams = null;
		this.purchase = null;
		this.selectedSuggestion = null;
		this.serviceBookingType = null;
		this.answeredQuestions = [];


		this.router.navigate(['/agent']);
		return;
	}

	public serviceQuestionSchema: Record<string, any>;
	public selectedSchema: string;
	companyQuestionsForm: FormGroup = new FormGroup({});

	startQuestions: any;
	type_of_ceremony: any;
	public totalCost: any;
	public firstSlotAnalytic: any;
	public firstSlotAnalyticKey: string;

	public childDob: any = false;

	public reference: any

	public isCitizenshipRoute: any;

	public _extraItems = [];

	public dateCapInitDate: any; // used to cap calendar dates one year from entered date

	public lookupResponses: any[] = [];

	public familyCitizenshipBooking = false;

	public groupCitizenshipBooking = false;

	type_of_appointment: any;

	appointment_type: any;

	public deepLinkedService: any;
	public deepLinkedResource: any;

	// client details
	public booker_first_name: any;
	public booker_last_name: any;
	public booker_email: any;
	public booker_phone: any;

	public storedFee: any;

	public costBreakDown: any;

	public setService: any;
	public setResource: any;

	public extraDuration: Number = 0; // obtained from questions

	router = inject(Router);
	constructor() { }

	public bookingQuestions = [];

	public unselectedLocations = [];

	public staff_set: any;
	public autoSelectedStaff: any;

	public bookingForm;
	public companyAnswers;
	public pageContent: any;

	public ceremonyDate: any;

	public deathDate: any;

	public mccdRegDate: any;

	public journeyRoute: string;

	public skipLocationsPage = false;

	public postageCounts: any;

	public selectedDate;

	public selectSlot;
	public selectedSlot;

	public selectedResource;

	public selectedService; //used only to store the service incase we switch to the alt one
	public selectedDepartment; //used only to store the service incase we switch to the alt one

	public locations = [];

	public bookingAnswers;

	public customerDetailsForm;

	public client;

	// SUP-2502: the welcome email is sent from the confirmation page, and the
	// paid journey reaches it through a full page reload on the way back from
	// the payment gateway. sessionStorage is per tab and survives that round
	// trip, so the flag still says whether this customer was new.
	private static readonly CLIENT_CREATED_KEY = 'client_created';

	// The booking the confirmation page reads back from localStorage carries the
	// customer's email but no member id, and `client` above is in-memory only,
	// so the id has to be kept here too or the welcome email has no-one to go to.
	private static readonly CREATED_CLIENT_KEY = 'created_client';

	private clientCreatedInMemory = false;

	public get createdClient(): { id: any; email: any } | null {
		try {
			const stored = sessionStorage.getItem(
				DatastoreService.CREATED_CLIENT_KEY
			);
			return stored ? JSON.parse(stored) : null;
		} catch (err) {
			return null;
		}
	}

	public get clientCreated(): boolean {
		try {
			return (
				sessionStorage.getItem(DatastoreService.CLIENT_CREATED_KEY) === 'true'
			);
		} catch (err) {
			return this.clientCreatedInMemory;
		}
	}

	public set clientCreated(created: boolean) {
		this.clientCreatedInMemory = created;
		try {
			if (created) {
				sessionStorage.setItem(DatastoreService.CLIENT_CREATED_KEY, 'true');
				// Every caller assigns `client` immediately before setting this.
				sessionStorage.setItem(
					DatastoreService.CREATED_CLIENT_KEY,
					JSON.stringify({
						id: this.client?.id,
						email: this.client?.email,
					})
				);
			} else {
				sessionStorage.removeItem(DatastoreService.CLIENT_CREATED_KEY);
				sessionStorage.removeItem(DatastoreService.CREATED_CLIENT_KEY);
			}
		} catch (err) {
			// Storage can be blocked; the in-memory copy still covers the paths
			// that do not reload the page.
		}
	}

	public address;

	public latitude;

	public longitude;

	public endSlot;

	public customerQuestions;

	public companyQuestions;

	public address1;

	public selectedLocation;

	public booking;

	public totalPrice;

	public adminJourney: boolean = false;

	public adminAuthToken: string = '';

	public purchase: any;

	public serviceBookingType: any;

	public selectedSuggestion: any;

	public config: any;

	public serviceFees: any;
	// True when /fees answered 404 ("we could not price this") for the current
	// selection. While set, the journey must not show a price or start checkout —
	// an unpriced ceremony is not bookable online, it is NOT free.
	public feesUnavailable = false;

	public queryParams: any;

	answeredQuestions: { id: string; answer: string }[] = [];

	makeItYoursPaymentType: string;

	selectedAddress: any;

	notify: Subject<boolean> = new Subject<boolean>();
	onNotify(event) {
		this.notify.next(true);
	}

	private addFeesSubject = new BehaviorSubject<any>(null);
	addFees$ = this.addFeesSubject.asObservable();
	triggerAddFees(fees: any) {
		this.addFeesSubject.next(fees);
	}
}
